const ru = {
  home: {
    createNewButton: "Создать новый XML",
    uploadHeading: "Загрузить XML",
    intro: "Легко управляйте XML лентами подкастов",
    footerHeading: "Получите максимум от управления подкастами",
    footerText1:
      "Зачем регистрироваться? У вас будет доступ к сохраненным данным с любого устройства.",
    footerText2:
      "Получите доступ к функциям уровня PRO, таким как история версий подкастов, расширенное валидирование и проверка, хостинг лент, обновление метаданных аудиофайлов и многое другое!",
    signupButton: "Зарегистрироваться",
    loginText: "Войти",
  },
  navbar: {
    editorLink: "Редактор",
    uploadLink: "Загрузить XML",
    createLink: "Создать новый",
    saveLink: "Сохранить в браузере",
    loadLink: "Загрузить из браузера",
    publishLink: "Опубликовать XML",
    openXMLLink: "URL-адрес опубликованного XML",
    settingsLink: "Настройки аккаунта",
    logoutLink: "Выйти",
    signupLink: "Зарегистрироваться",
    loginLink: "Войти в систему",
  },
  statusBar: {
    verifyButton: "Проверить данные",
    exportButton: "Экспорт XML",
    allValidStatus: "Все поля заполнены верно",
    generalValidStatus: "Нет ошибок в общих данных о подкасте",
    episodeInvalidStatus:
      "В {{count}} выпуске есть ошибки или недопустимые данные.",
    episodeInvalidStatus_plural:
      "В {{count}} выпусках есть ошибки или недопустимые данные.",
    generalInvalidStatus: "Есть ошибки в заполненных полях",
  },
  tabs: {
    generalTab: "О подкасте",
    episodeTab: "Редакт. эпизод",
    episodeListTab: "Эпизоды",
  },
  generalForm: {
    mainTitle: "Общая информация о подкасте",
    titleLabel: "Название подкаста",
    titleError: "Название подкаста обязательно, минимум 2 символа.",
    imageUrlLabel: "URL-адрес изображения, используемый подкаст плеерами",
    imageUrlDescription:
      "Поддерживаемые форматы JPG, PNG или GIF. Рекомендуемое разрешение 1400x1400 px.",
    imageUrlError:
      "Укажите правильный URL-адрес, начинающийся с http:// или https://",
    subtitleLabel: "Подзаголовок подкаста",
    subtitleError: "Подзаголовок подкаста необходим.",
    summaryLabel: "Описание подкаста",
    summaryError: "Описание должно быть не менее 10 букв.",
    authorLabel: "Автор(ы) подкаста",
    authorError: "Имя должно быть не менее 2 букв.",
    ownerLabel: "Владелец подкаста",
    ownerTip: "Название компании или то же, что и автор",
    ownerError: "Обязательно, минимум 2 символа.",
    websiteUrlLabel: "URL-адрес веб-сайта подкаста",
    websiteUrlError:
      "Укажите правильный URL-адрес, начинающийся с http:// или https://",
    languageLabel: "Язык (примеры: en, ru, es-MX, fr-CA и т.д.)",
    languageError:
      "По крайней мере один язык должен быть указан в нужном формате.",
    copyrightLabel: "Авторские права",
    copyrightError:
      "Необходимо ввести авторские права, если не уверены, введите свое имя.",
    contactEmailLabel: "Имеил для связи",
    contactEmailError: "Укажите действующий адрес электронной почты.",
    categoriesLabel: "Категории подкастов в iTunes",
    categoriesTip: "Они определены Apple. Укажите хотя бы один.",
    categoriesEditLink: "Редактировать",
    categoriesSelectLink: "Выбрать",
    categoriesError: "Выберите хотя бы одну категорию",
    keywordsLabel: "Ключевые слова (через запятую)",
    keywordsError: "Введите хотя бы одно ключевое слово.",
    ageRestrictionLabel: "Возрастные ограничения для всего подкаста",
    ageRestrictionTip: "Clean - подходит для аудитории младше 18 лет.",
    ageRestrictionClean: "Для всех",
    ageRestrictionExplicit: "18+",
    ageRestrictionError: "Выберите один вариант",
    updadingLabel: "Обновляем...",
  },
  episodeForm: {
    mainTitle: "Редактировать выпуск",
    unselectedText:
      "Выберите выпуск из списка, чтобы увидеть его детали и редактировать.",
    previewLink: "Просмотр",
    previewFallbackEpisodeName: "Название выпуска",
    previewFallbackPodcastName: "Введите название подкаста",
    previewFallbackImageUrl: "Введите URL картинки обложки подкаста",
    previewFallbackDate: "Введите дату выпуска",
    previewFallbackTime: "Время выпуска",
    previewFallbackSubtitle: "Подзаголовок выпуска появится здесь",
    previewFallbackFileURL: "Введите URL аудиофайла выпуска",
    previewFallbackDescription:
      "Введите описание выпуска, чтобы увидеть его здесь.",
    titleLabel: "Заголовок",
    titleError: "Укажите название выпуска.",
    subtitleLabel: "Подзаголовок",
    subtitleError: "Нужен подзаголовок эпизода.",
    descriptionLabel: "Описание",
    descriptionError: "Описание должно быть не менее 4 символов.",
    releaseDateLabel: "Дата выхода",
    releaseDateError: "Укажите дату",
    releaseDateNow: "Сейчас",
    releaseDateTip: "Месяц, день, год, время в формате 12 часов AM/PM",
    timeLabel: "Время (пример: 12:00 PM)",
    timeError: "Требуется время",
    fileUrlLabel: "URL-адрес файла MP3",
    fileUrlError: "Укажите URL-адрес для аудиофайла типа .mp3 или .m4a.",
    fileSizeLabel: "Размер аудиофайла в байтах",
    fileSizeError: "Введите правильную размер файла.",
    durationLabel: "Продолжительность",
    hoursLabel: "Часы",
    hoursError: "Часы задаются числами",
    minutesLabel: "Минуты",
    minutesError: "Минуты задаются числами",
    minutesError2: "Минут должно быть менее 60, если указаны часы.",
    secondsLabel: "Секунды",
    secondsError: "Введите правильное количество секунд.",
    secondsError2: "Секунд должно быть меньше 60, если указаны минуты.",
    ageRestrictionLabel: "Ограничения по возрасту для данного выпуска",
    ageRestrictionClean: "Для всех",
    ageRestrictionExplicit: "18+",
    ageRestrictionError: "Выберите один вариант",
  },
  forceExportModal: {
    title: "Внимание",
    text1: "Эта лента содержит неверные или отсутствующие данные.",
    text2:
      "Сгенерируйте XML учитывая риск того, что он может вызвать ошибки на Apple Podcasts Connect и других сервисах для подкастов.",
    closeButton: "Отменить",
    forceExportButton: "Всё равно экспортировать",
  },
  uploadXML: {
    inputLabel: "URL-адрес файла",
    submitButton: "Загрузить",
    verticalSeparator: "или",
    selectFileButton: "Выбрать файл",
    dropText: "или перетащите файл сюда",
  },
  episodeList: {
    mainTitle: "Выпуски",
    newButton: "Новый",
    episodeError: "Требуется хотя бы один выпуск",
    episodeTitleFallback: "Название выпуска",
    episodeDateFallback: "Дата публикации",
    deleteLink: "Удалить",
  },
  footer: {
    copyright: "© 2022 Techlife Syndicate",
    version: "Ver",
    privacyLink: "Политика конфиденциальности",
    termsLink: "Условия использования",
  },
  signup: {
    formTitle: "Зарегистрироваться",
    firstnameLabel: "Имя",
    firstnamePlaceholder: "Имя",
    firstnameMinError: "Имя должно быть не менее 2 букв",
    firstnameMaxError: "Имя должно содержать не более 15 букв.",
    firstnameReqError: "Требуется имя",
    lastnameLabel: "Фамилия",
    lastnamePlaceholder: "Фамилия",
    lastnameMinError: "Фамилия должна быть не менее 2 букв",
    lastnameMaxError: "Фамилия должна содержать не более 15 букв.",
    lastnameReqError: "Требуется фамилия",
    emailLabel: "Электронная почта",
    emailPlaceholder: "Электронная почта",
    emailTypeError: "Введите правильный адрес электронной почты",
    emailReqError: "Электронная почта является обязательным полем",
    passwordLabel: "Пароль",
    passwordPlaceholder: "Пароль",
    passwordMinError: "Пароль должен быть не менее 8 символов",
    passwordReqError: "Необходим пароль",
    signupButton: "Зарегистрироваться",
    signupButtonLoading: "Подписываясь...",
    memberText: "Уже зарегистрированы?",
    loginLink: "Авторизоваться",
    mainHeading:
      "Создавайте и редактируйте XML файлы для подкастов с лёгкостью",
    subHeading: "Зачем регистрироваться?",
    text1: "Мы поможем работать с подкастами легче и быстрей.",
    text2:
      "Получите доступ к функциям PRO, таким как история версий каналов, расширенная проверка, хостинг каналов, обновление метаданных аудиофайлов и многое другое!",
  },
  login: {
    formTitle: "Авторизоваться",
    emailLabel: "Электронная почта",
    emailPlaceholder: "Электронная почта",
    emailTypeError:
      "Электронная почта должна быть действительным адресом электронной почты",
    emailReqError: "Электронная почта является обязательным полем",
    passwordLabel: "Пароль",
    passwordPlaceholder: "Пароль",
    passwordMinError: "Пароль должен быть не менее 8 символов",
    passwordReqError: "Необходим пароль",
    loginButton: "Войти",
    loginButtonLoading: "Вход в систему...",
    notMember: "Нет аккаунта?",
    signupLink: "Зарегистрироваться",
  },
  profile: {
    formTitle: "Профиль пользователя",
    updateProfileLabel: "Обновить данные",
    updatePasswordLabel: "Обновить пароль",
    currentPasswordLabel: "Текущий пароль",
    newPasswordLabel: "Новый пароль",
    avatarTitleLabel: "Фото пользователя",
    changeAvatarLabel: "Изменить фото",
    deleteAccountLink: "Удалить аккаунт",
  },
  delete: {
    title: "Удалить аккаунт",
    warningText:
      "Вы уверены, что хотите удалить свой аккаунт? Это необратимое действие и вы навсегда потеряете все данные, записанные на сервере.",
    buttonText: "Удалить ваш аккаунт",
  },
  backToEditorText: "Вернуться к редактору",
};

export default ru;
